<template>
  <div>

    <v-dialog v-model="dialog" persistent width="50%">

      <v-card>
        <v-card-title>
          <span class="headline">Inloggen</span>
        </v-card-title>
        <v-card-text>
          <v-container grid-list-md>
            <v-layout wrap>

              <v-flex xs12>
                <v-text-field  label="Email" required v-model="email"></v-text-field>
              </v-flex>
              <v-flex xs12>
                <v-text-field label="Password" type="password" required v-model="paswoord"></v-text-field>
              </v-flex>

            </v-layout>
          </v-container>
          <small>*indicates required field</small>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn class="blue--text darken-1" flat @click.native="dialog = false">Annuleer</v-btn>
          <v-btn class="blue--text darken-1" flat @click.native="Inloggen">OK</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="toonPlanVenster" persistent width="50%">

      <v-card>
        <v-card-title>
          <span class="headline">{{dagZin}}   ({{klas}})</span>
        </v-card-title>
        <v-card-text>
          <v-form>

            <v-text-field
              append-icon="assignment"
              class="groot"
              label="Taken"
              v-model="actieveTaak"
            ></v-text-field>
            <v-text-field
              append-icon="feedback"
              class="groot"
              label="Lessen"
              v-model="actieveLes"
            ></v-text-field>
            <v-text-field
              append-icon="date_range"
              class="groot"
              label="Planning"
              v-model="actievePlanning"
            ></v-text-field>

          </v-form>

        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn class="blue--text darken-1" flat @click.native="AnnuleerInvoer">Annuleer</v-btn>
          <v-btn class="blue--text darken-1" flat @click.native="SlaDagOp">OK</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>


    <table>
      <tr>
        <td><dagschema extradagen="0" :week="week" ></dagschema></td>
        <td><dagschema extradagen="0" :week="week+1" :isRegistered="registered"></dagschema></td>
        <td><dagschema extradagen="0" :week="week+2"></dagschema></td>
      </tr>
      <tr>
        <td><dagschema extradagen="1" :week="week" ></dagschema></td>
        <td><dagschema extradagen="1" :week="week+1" ></dagschema></td>
        <td><dagschema extradagen="1" :week="week+2" ></dagschema></td>

      </tr>
      <tr>
        <td><dagschema extradagen="2" :week="week" ></dagschema></td>
        <td><dagschema extradagen="2" :week="week+1" ></dagschema></td>
        <td><dagschema extradagen="2" :week="week+2" ></dagschema></td>

      </tr>
      <tr>
        <td><dagschema extradagen="3" :week="week" ></dagschema></td>
        <td><dagschema extradagen="3" :week="week+1" ></dagschema></td>
        <td><dagschema extradagen="3" :week="week+2" ></dagschema></td>

      </tr>
      <tr>
        <td><dagschema extradagen="4" :week="week" ></dagschema></td>
        <td><dagschema extradagen="4" :week="week+1" ></dagschema></td>
        <td><dagschema extradagen="4" :week="week+2" ></dagschema></td>

      </tr>


    </table>
    <v-btn
      fixed

      dark
      fab
      bottom
      right
      class="pink"
      @click="weekbij"
    >
      <v-icon>keyboard_arrow_right</v-icon>
    </v-btn>

    <v-btn
      fixed
      dark
      fab
      bottom
      left
      class="pink"
      @click="weekweg"
    >
      <v-icon>keyboard_arrow_left</v-icon>
    </v-btn>
    <div class="text-xs-center">
     <v-btn
        fixed
        dark
        fab
        bottom
        @click="laadGegevens"
        class="red"

      >
       {{klas}}
      </v-btn>
      <v-btn primary dark @click="toonVenster" class="ml-5" v-show="!registered">Log in</v-btn>
      <v-btn primary dark @click="Uitloggen" class="ml-5" v-show="registered">Uitloggen</v-btn>

    </div>
  </div>

</template>
<script>
  import dagschema from '@/components/dagschema.vue'
  import * as firebase from 'firebase'
  export default {
    props:["klas"],
    data(){
      return{
        week:0,
        dialog:false,
        email:null,
        paswoord:null,
        actieveLes:"",
        actievePlanning:"",
        actieveTaak:""




      }
    },
    components:{
      dagschema
    },


    methods:{
      laadGegevens(){
        var lijst = firebase.database().ref(this.klas).once('value').then(
          (data)=>{
            const agendaPunten = []
            const obj = data.val()
            for(let key in obj){
              console.log(key)
              agendaPunten.push({
                id:key,
                datum:obj[key].datum,
                les:obj[key].les,
                taak:obj[key].taak,
                planning:obj[key].planning
              })
            }
            this.$store.state.agendaPunten = agendaPunten

          }
        ).catch(
          (error) => {console.log(error)}
        )
      },
      AnnuleerInvoer(){
        this.$store.state.vulAan = false;

      },
      SlaDagOp(){
        var dag = {}
        dag.les = this.actieveLes
        dag.taak = this.actieveTaak
        dag.planning = this.actievePlanning
        dag.datum = this.$store.state.actieveDag
        if(this.$store.state.actieveDatumBestaat == false) {
          console.log("nieuwe gegevens")
          firebase.database().ref(this.klas).push(dag).then(
            this.laadGegevens()
          )
        }else{
          console.log("gegevens updaten van")
          console.log(this.$store.state.actieveKey)
          firebase.database().ref(this.klas).child(this.$store.state.actieveKey).update(dag).then(
            this.laadGegevens()
          )
        }


            this.$store.state.vulAan = false

      },
      weekbij(){
        this.week+=1
      },
      weekweg(){
        this.week-=1
      },
      toonVenster(){
        this.dialog=true
      },
      Uitloggen(){
        this.$store.state.registered = false
      },
      Inloggen(){
        firebase.auth().signInWithEmailAndPassword(this.email,this.paswoord)
          .then(
            user=>{
              console.log(user.uid +"is logged in")
              this.$store.state.registered = true
              this.dialog = false
            }
          )
          .catch(
            error=>{
              console.log(error)
            }
          )

      }

    },
    watch:{
      toonPlanVenster(value){
        if(value == true){


          this.actieveTaak = this.$store.state.actieveTaak
          this.actieveLes = this.$store.state.actieveLes
          this.actievePlanning = this.$store.state.actievePlanning

          console.log("toon dat venster maar!")
        }

      }
    },
    computed:{
      dag(){
        return this.$store.state.actieveDag
      },
      dagZin(){
        return this.$store.state.actieveDagZin
      },
      registered(){
        return this.$store.state.registered
      },
      toonPlanVenster(){
        var rv = false;
        if(this.$store.state.registered){
          rv = this.$store.state.vulAan
        }

        return rv
      },

      vulAan(){
        if(this.$store.state.vulAan == true){

        }
      },




    },
    created(){
      var lijst = firebase.database().ref(this.klas).once('value').then(
            (data)=>{
              const agendaPunten = []
              const obj = data.val()
              for(let key in obj){
                console.log(key)
                agendaPunten.push({
                  id:key,
                  datum:obj[key].datum,
                  les:obj[key].les,
                  taak:obj[key].taak,
                  planning:obj[key].planning
                })
              }
              this.$store.state.agendaPunten = agendaPunten

        }
      ).catch(
        (error) => {console.log(error)}
      )
    }

  }

</script>
<style>
table{
  width:100%
}
  td{
    border:1px solid black
  }
.input-group--text-field input, .input-group--text-field textarea {
  caret-color: #1976d2;
  font-size: 32px;
}

</style>



// WEBPACK FOOTER //
// src/components/hoofdscherm.vue